import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import type { PortfolioItem } from "./saveItemToProfile";

interface PortfolioUpdate {
  uuid: string;
  portfolio: PortfolioItem[];
  /** Only these ids are removed; any other stored item missing from `portfolio` is kept. */
  removed_ids: string[];
}

/**
 * Saves the profile's edited portfolio list. Removing a file or video also
 * removes it from the candidate's floats and submissions, so usage is refetched.
 */
export default function useUpdatePortfolio() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ uuid, portfolio, removed_ids }: PortfolioUpdate) => {
      return axios.patch(`/candidate/${uuid}/portfolio`, { portfolio, removed_ids });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.uuid], data);

      return client.invalidateQueries({ queryKey: ["candidatePortfolioUsage", variables.uuid] });
    },
  });
}
